<template>
	<div id="marketstudies-index"
		 class="app-home ui-styles"
		 :class="theme">
		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :bdefilesOpen="bdefilesOpen"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('BDE_files') }}</h1>
					<h1 v-if="filesyear">{{ filesyear }}</h1>
					<vue-tabs>
						<v-tab :title="bde_appraisal_files_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">

										<div class="section-container">
											<h3>Tasaciones {{ filesyear }}</h3>
											<h4>Resumen:</h4>
											<table class="table-striped calc" style="margin-bottom: 3em;">
												<tr>
													<td>
														<small><strong>Número de tasaciones</strong></small>
													</td>
													<td>
														<small>{{ numtasaciones }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Suma del valor de tasaciones</strong></small>
													</td>
													<td>
														<small>{{ valortasaciones | formatNumber }} €</small>
													</td>
												</tr>
											</table>
											<h4>Fichero de entrega BdE:</h4>
											<div class="field-container">

												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenAppraisalFile"
															@keyup.enter="onOpenAppraisalFile">
										<span><icon name="external-link" scale="0.8"
													color="rgb(0, 79, 146)"></icon>&nbsp;<small>Abrir ficha de entrega</small></span>
													</button>
												</div>
												<div class="field__group">
													<label class="field__group__label">Separador ";"</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="separator"
														   @click="set_separator">
												</div>
												<div class="field__group">
												</div>
											</div>
											<br>
											<h4>Fichas individuales:</h4>
											<table class="table-striped calc"
												   v-for="(value, key) in bde_appraisal_files[filesyear]"
												   style="margin-bottom: 3em;">
												<caption style="text-align: left">
													<small><strong># {{ key }}  {{ value._id }} </strong></small>
												</caption>
												<tr>
													<th width="200px" style="text-align: right">
														<small><strong>Campo</strong></small>
													</th>
													<th width="40px" style="text-align: right">
														<small>Nº</small>
													</th>
													<th width="70px" style="text-align: right">
														<small>Formato</small>
													</th>
													<th width="300px" style="text-align: right">
														<small>Valor</small>
													</th>
												</tr>
												<tr>
													<td>
														<small><strong>Código sociedad</strong></small>
													</td>
													<td>
														<small>1</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c01_cod_sociedad }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Fecha de referencia</strong></small>
													</td>
													<td>
														<small>2</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c02_fecha_ref }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Número de tasación</strong></small>
													</td>
													<td>
														<small>3</small>
													</td>
													<td>
														<small>9(20)</small>
													</td>
													<td>
														<small>{{ value.c03_num_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Fecha de tasación</strong></small>
													</td>
													<td>
														<small>4</small>
													</td>
													<td>
														<small>9(8)</small>
													</td>
													<td>
														<small>{{ value.c04_fecha_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Tipo de tasación</strong></small>
													</td>
													<td>
														<small>5</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c05_tipo_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Finalidad de tasación</strong></small>
													</td>
													<td>
														<small>6</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c06_finalidad_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>s/ Ley Mercado Hipotecario</strong></small>
													</td>
													<td>
														<small>7</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c07_sigue_leymh }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>s/ ECO/805/2003</strong></small>
													</td>
													<td>
														<small>8</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c08_sigue_eco }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Advertencias</strong></small>
													</td>
													<td>
														<small>9</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c09_hay_advertencias }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Condicionantes</strong></small>
													</td>
													<td>
														<small>10</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c10_hay_condicionantes }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor tasación</strong></small>
													</td>
													<td>
														<small>11</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c11_valor_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Importe facturado</strong></small>
													</td>
													<td>
														<small>12</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c12_importe_facturado }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>NIF mandatario</strong></small>
													</td>
													<td>
														<small>13</small>
													</td>
													<td>
														<small>X(11)</small>
													</td>
													<td>
														<small>{{ value.c13_nif_mandatario }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nombre mandatario</strong></small>
													</td>
													<td>
														<small>14</small>
													</td>
													<td>
														<small>X(60)</small>
													</td>
													<td>
														<small>{{ value.c14_nombre_mandatario }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Código BdE mandatario</strong></small>
													</td>
													<td>
														<small>15</small>
													</td>
													<td>
														<small>X(4)</small>
													</td>
													<td>
														<small>{{ value.c15_codigo_mandatario }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>NIF solicitante</strong></small>
													</td>
													<td>
														<small>16</small>
													</td>
													<td>
														<small>X(11)</small>
													</td>
													<td>
														<small>{{ value.c16_nif_solicitante }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nombre solicitante</strong></small>
													</td>
													<td>
														<small>17</small>
													</td>
													<td>
														<small>X(60)</small>
													</td>
													<td>
														<small>{{ value.c17_nombre_solicitante }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>NIF tasador</strong></small>
													</td>
													<td>
														<small>18</small>
													</td>
													<td>
														<small>X(11)</small>
													</td>
													<td>
														<small>{{ value.c18_nif_tasador }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nombre tasador</strong></small>
													</td>
													<td>
														<small>19</small>
													</td>
													<td>
														<small>X(60)</small>
													</td>
													<td>
														<small>{{ value.c19_nombre_tasador }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>NIF supervisor</strong></small>
													</td>
													<td>
														<small>20</small>
													</td>
													<td>
														<small>X(11)</small>
													</td>
													<td>
														<small>{{ value.c20_nif_supervisor }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nombre supervisor</strong></small>
													</td>
													<td>
														<small>21</small>
													</td>
													<td>
														<small>X(60)</small>
													</td>
													<td>
														<small>{{ value.c21_nombre_supervisor }}</small>
													</td>
												</tr>


											</table>

										</div>
									</form>
								</div>

							</div>
						</v-tab>
						<v-tab :title="bde_realestate_files_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">

										<div class="section-container">
											<h3>Inmuebles {{ filesyear }}</h3>
											<!--<pre>{{ bde_realestate_files }}</pre>-->
											<h4>Resumen:</h4>
											<table class="table-striped calc" style="margin-bottom: 3em;">
												<tr>
													<td>
														<small><strong>Número de inmuebles</strong></small>
													</td>
													<td>
														<small>{{ numinmuebles }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Suma del valor de inmuebles</strong></small>
													</td>
													<td>
														<small>{{ valorinmuebles | formatNumber }} €</small>
													</td>
												</tr>
											</table>
											<h4>Fichero de entrega BdE:</h4>
											<div class="field-container">

												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenRealestateFile"
															@keyup.enter="onOpenRealestateFile">
										<span><icon name="external-link" scale="0.8"
													color="rgb(0, 79, 146)"></icon>&nbsp;<small>Abrir ficha de entrega</small></span>
													</button>
												</div>
												<div class="field__group">
													<label class="field__group__label">Separador ";"</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="separator"
														   @click="set_separator">
												</div>
												<div class="field__group">
												</div>
											</div>
											<br>
											<h4>Fichas individuales:</h4>

											<table class="table-striped calc"
												   v-for="(value, key) in bde_realestate_files[filesyear]"
												   style="margin-bottom: 3em;">
												<caption style="text-align: left">
													<small><strong># {{ key }} </strong></small>
												</caption>
												<tr>
													<th width="200px" style="text-align: right">
														<small><strong>Campo</strong></small>
													</th>
													<th width="40px" style="text-align: right">
														<small>Nº</small>
													</th>
													<th width="70px" style="text-align: right">
														<small>Formato</small>
													</th>
													<th width="300px" style="text-align: right">
														<small>Valor</small>
													</th>
												</tr>
												<tr>
													<td>
														<small><strong>Código sociedad</strong></small>
													</td>
													<td>
														<small>1</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c01_inm_cod_sociedad }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Fecha de referencia</strong></small>
													</td>
													<td>
														<small>2</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c02_inm_fecha_ref }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Número de tasación</strong></small>
													</td>
													<td>
														<small>3</small>
													</td>
													<td>
														<small>9(20)</small>
													</td>
													<td>
														<small>{{ value.c03_inm_num_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº elemento en informe</strong></small>
													</td>
													<td>
														<small>4</small>
													</td>
													<td>
														<small>9(3)</small>
													</td>
													<td>
														<small>{{ value.c04_inm_num_elemento }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Tipo de activo</strong></small>
													</td>
													<td>
														<small>5</small>
													</td>
													<td>
														<small>X(3)</small>
													</td>
													<td>
														<small>{{ value.c05_inm_tipo_activo }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Tipo de vivienda</strong></small>
													</td>
													<td>
														<small>6</small>
													</td>
													<td>
														<small>9(1)</small>
													</td>
													<td>
														<small>{{ value.c06_inm_tipo_vivienda }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Uso del inmueble</strong></small>
													</td>
													<td>
														<small>7</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c07_inm_tipo_uso }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Estado ocupación</strong></small>
													</td>
													<td>
														<small>8</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c08_inm_estado_ocupacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Visita interior</strong></small>
													</td>
													<td>
														<small>9</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c09_inm_visita_interior }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Estado construcción</strong></small>
													</td>
													<td>
														<small>10</small>
													</td>
													<td>
														<small>X(3)</small>
													</td>
													<td>
														<small>{{ value.c10_inm_estado_construccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Año construcción</strong></small>
													</td>
													<td>
														<small>11</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c11_inm_ano_construccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Año última rehab.</strong></small>
													</td>
													<td>
														<small>12</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c12_inm_ano_ultima_rehab }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Método valoración</strong></small>
													</td>
													<td>
														<small>13</small>
													</td>
													<td>
														<small>X(3)</small>
													</td>
													<td>
														<small>{{ value.c13_inm_metodo_valoracion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor tasación</strong></small>
													</td>
													<td>
														<small>14</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c14_inm_valor_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor hipótesis edificio terminado</strong>
														</small>
													</td>
													<td>
														<small>15</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c15_inm_valor_hipotesis_edif_terminado }}
														</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor reemplazamiento neto</strong></small>
													</td>
													<td>
														<small>16</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c16_inm_valor_reemplazamiento_neto }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor máximo legal</strong></small>
													</td>
													<td>
														<small>17</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c17_inm_valor_max_legal }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor actualización rentas</strong></small>
													</td>
													<td>
														<small>18</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c18_inm_valor_actualizacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor comparación</strong></small>
													</td>
													<td>
														<small>19</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c19_inm_valor_comparacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Ajuste valor comparación</strong></small>
													</td>
													<td>
														<small>20</small>
													</td>
													<td>
														<small>9(3)v9(2)</small>
													</td>
													<td>
														<small>{{ value.c20_inm_ajuste_valor_comparacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor hipotecario</strong></small>
													</td>
													<td>
														<small>21</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c21_inm_valor_hipotecario }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>País</strong></small>
													</td>
													<td>
														<small>22</small>
													</td>
													<td>
														<small>X(2)</small>
													</td>
													<td>
														<small>{{ value.c22_inm_pais }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Código INE Prov. + Mun.</strong></small>
													</td>
													<td>
														<small>23</small>
													</td>
													<td>
														<small>X(5)</small>
													</td>
													<td>
														<small>{{ value.c23_inm_codigo_ine }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Municipio</strong></small>
													</td>
													<td>
														<small>24</small>
													</td>
													<td>
														<small>X(50)</small>
													</td>
													<td>
														<small>{{ value.c24_inm_nombre_municipio }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Dirección</strong></small>
													</td>
													<td>
														<small>25</small>
													</td>
													<td>
														<small>X(60)</small>
													</td>
													<td>
														<small>{{ value.c25_inm_direccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Código Postal</strong></small>
													</td>
													<td>
														<small>26</small>
													</td>
													<td>
														<small>X(5)</small>
													</td>
													<td>
														<small>{{ value.c26_inm_codigo_postal }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Referencia Catastral</strong></small>
													</td>
													<td>
														<small>27</small>
													</td>
													<td>
														<small>X(20)</small>
													</td>
													<td>
														<small>{{ value.c27_inm_ref_catastral }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>IDUFIR</strong></small>
													</td>
													<td>
														<small>28</small>
													</td>
													<td>
														<small>X(14)</small>
													</td>
													<td>
														<small>{{ value.c28_inm_idufir }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Sección Censal</strong></small>
													</td>
													<td>
														<small>29</small>
													</td>
													<td>
														<small>X(11)</small>
													</td>
													<td>
														<small>{{ value.c29_inm_seccion_censal }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Longitud EPSG:4326</strong></small>
													</td>
													<td>
														<small>30</small>
													</td>
													<td>
														<small>-9(3)v9(7)</small>
													</td>
													<td>
														<small>{{ value.c30_inm_longitud_geolocalizacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Latitud EPSG:4326</strong></small>
													</td>
													<td>
														<small>31</small>
													</td>
													<td>
														<small>-9(3)v9(7)</small>
													</td>
													<td>
														<small>{{ value.c31_inm_latitud_geolocalizacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. Construida</strong></small>
													</td>
													<td>
														<small>32</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c32_inm_supf_const }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. Construida con Z. C.</strong></small>
													</td>
													<td>
														<small>33</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c33_inm_supf_const_con_zc }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. Útil</strong></small>
													</td>
													<td>
														<small>34</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c34_inm_supf_util }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. Catastral</strong></small>
													</td>
													<td>
														<small>35</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c35_inm_supf_catastral }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. Adoptada</strong></small>
													</td>
													<td>
														<small>36</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c36_inm_supf_adoptada }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. Parcela</strong></small>
													</td>
													<td>
														<small>37</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c37_inm_supf_parcela }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Valor unitario (€/m2)</strong></small>
													</td>
													<td>
														<small>38</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c38_inm_valor_unitario }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Costes construcción (€/m2)</strong></small>
													</td>
													<td>
														<small>39</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c39_inm_costes_construccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Otros gastos necesarios (€/m2)</strong></small>
													</td>
													<td>
														<small>40</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c40_inm_otros_gastos_unitarios }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº baños</strong></small>
													</td>
													<td>
														<small>41</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c41_inm_num_banos }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº dormitorios</strong></small>
													</td>
													<td>
														<small>42</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c42_inm_num_dormitorios }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Zonas verdes</strong></small>
													</td>
													<td>
														<small>43</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c43_inm_zonas_verdes }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Piscina</strong></small>
													</td>
													<td>
														<small>44</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c44_inm_piscina }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Zonas deportivas</strong></small>
													</td>
													<td>
														<small>45</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c45_inm_zonas_deportivas }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Calefacción</strong></small>
													</td>
													<td>
														<small>46</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c46_inm_calefaccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Aire acondicionado</strong></small>
													</td>
													<td>
														<small>47</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c47_inm_aire_acondicionado }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Calidad construcción</strong></small>
													</td>
													<td>
														<small>48</small>
													</td>
													<td>
														<small>9(1)</small>
													</td>
													<td>
														<small>{{ value.c48_inm_calidad_construccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Estado conservación</strong></small>
													</td>
													<td>
														<small>49</small>
													</td>
													<td>
														<small>9(1)</small>
													</td>
													<td>
														<small>{{ value.c49_estado_conservacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Terraza cubierta (m2)</strong></small>
													</td>
													<td>
														<small>50</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c50_inm_m2_terraza_cubierta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Terraza descubierta (m2)</strong></small>
													</td>
													<td>
														<small>51</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c51_inm_m2_terraza_descubierta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Ascensor</strong></small>
													</td>
													<td>
														<small>52</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c52_inm_ascensor }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº planta</strong></small>
													</td>
													<td>
														<small>53</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c53_inm_num_planta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Tipo planta</strong></small>
													</td>
													<td>
														<small>54</small>
													</td>
													<td>
														<small>X(2)</small>
													</td>
													<td>
														<small>{{ value.c54_inm_tipo_planta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº plazas garaje</strong></small>
													</td>
													<td>
														<small>55</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c55_inm_plazas_garaje }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Trastero</strong></small>
													</td>
													<td>
														<small>56</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c56_inm_trastero }}</small>
													</td>
												</tr>


											</table>

										</div>
									</form>
								</div>

							</div>
						</v-tab>
						<v-tab :title="bde_comparable_files_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">

										<div class="section-container">
											<h3>Comparables {{ filesyear }}</h3>
											<!--<pre>{{ bde_comparable_files }}</pre>-->
											<h4>Resumen:</h4>
											<table class="table-striped calc" style="margin-bottom: 3em;">
												<tr>
													<td>
														<small><strong>Número de comparables</strong></small>
													</td>
													<td>
														<small>{{ numcomparables }}</small>
													</td>
												</tr>

											</table>
											<h4>Fichero de entrega BdE:</h4>
											<div class="field-container">

												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenComparableFile"
															@keyup.enter="onOpenComparableFile">
										<span><icon name="external-link" scale="0.8"
													color="rgb(0, 79, 146)"></icon>&nbsp;<small>Abrir ficha de entrega</small></span>
													</button>
												</div>
												<div class="field__group">
													<label class="field__group__label">Separador ";"</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="separator"
														   @click="set_separator">
												</div>
												<div class="field__group">
												</div>
											</div>
											<br>
											<h4>Fichas individuales:</h4>
											<table class="table-striped calc"
												   v-for="(value, key) in bde_comparable_files[filesyear]"
												   style="margin-bottom: 3em;">
												<caption style="text-align: left">
													<small><strong># {{ key }} </strong></small>
												</caption>
												<tr>
													<th width="200px" style="text-align: right">
														<small><strong>Campo</strong></small>
													</th>
													<th width="40px" style="text-align: right">
														<small>Nº</small>
													</th>
													<th width="70px" style="text-align: right">
														<small>Formato</small>
													</th>
													<th width="300px" style="text-align: right">
														<small>Valor</small>
													</th>
												</tr>
												<tr>
													<td>
														<small><strong>Código sociedad</strong></small>
													</td>
													<td>
														<small>1</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c01_comp_cod_sociedad }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Fecha de referencia</strong></small>
													</td>
													<td>
														<small>2</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c02_comp_fecha_ref }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Código comparable</strong></small>
													</td>
													<td>
														<small>3</small>
													</td>
													<td>
														<small>X(20)</small>
													</td>
													<td>
														<small>{{ value.c03_comp_identificador }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Fecha captura</strong></small>
													</td>
													<td>
														<small>4</small>
													</td>
													<td>
														<small>9(8)</small>
													</td>
													<td>
														<small>{{ value.c04_comp_fecha_captura }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Tipo datos</strong></small>
													</td>
													<td>
														<small>5</small>
													</td>
													<td>
														<small>X(3)</small>
													</td>
													<td>
														<small>{{ value.c05_comp_tipo_datos }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Visita interior</strong></small>
													</td>
													<td>
														<small>6</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c06_comp_visita_interior }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Contraste info Catastro</strong></small>
													</td>
													<td>
														<small>7</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c07_comp_contraste_catastro }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Datos contacto</strong></small>
													</td>
													<td>
														<small>8</small>
													</td>
													<td>
														<small>X(12)</small>
													</td>
													<td>
														<small>{{ value.c08_comp_datos_contacto }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>País</strong></small>
													</td>
													<td>
														<small>9</small>
													</td>
													<td>
														<small>X(2)</small>
													</td>
													<td>
														<small>{{ value.c09_comp_pais }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Código INE Prov. + Mun.</strong></small>
													</td>
													<td>
														<small>10</small>
													</td>
													<td>
														<small>X(5)</small>
													</td>
													<td>
														<small>{{ value.c10_comp_codigo_ine }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Municipio</strong></small>
													</td>
													<td>
														<small>11</small>
													</td>
													<td>
														<small>X(50)</small>
													</td>
													<td>
														<small>{{ value.c11_comp_municipio }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Dirección</strong></small>
													</td>
													<td>
														<small>12</small>
													</td>
													<td>
														<small>X(60)</small>
													</td>
													<td>
														<small>{{ value.c12_comp_direccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Código postal</strong></small>
													</td>
													<td>
														<small>13</small>
													</td>
													<td>
														<small>X(5)</small>
													</td>
													<td>
														<small>{{ value.c13_comp_codigo_postal }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Referencia Catastral</strong></small>
													</td>
													<td>
														<small>14</small>
													</td>
													<td>
														<small>X(20)</small>
													</td>
													<td>
														<small>{{ value.c14_comp_ref_catastral }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>IDUFIR</strong></small>
													</td>
													<td>
														<small>15</small>
													</td>
													<td>
														<small>X(14)</small>
													</td>
													<td>
														<small>{{ value.c15_comp_idufir }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Sección Censal</strong></small>
													</td>
													<td>
														<small>16</small>
													</td>
													<td>
														<small>X(11)</small>
													</td>
													<td>
														<small>{{ value.c16_comp_seccion_censal }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Longitud EPSG:4326</strong></small>
													</td>
													<td>
														<small>17</small>
													</td>
													<td>
														<small>-9(3)v9(7)</small>
													</td>
													<td>
														<small>{{ value.c17_comp_longitud }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Latitud EPSG:4326</strong></small>
													</td>
													<td>
														<small>18</small>
													</td>
													<td>
														<small>-9(3)v9(7)</small>
													</td>
													<td>
														<small>{{ value.c18_comp_latitud }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Precio de oferta</strong></small>
													</td>
													<td>
														<small>19</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c19_comp_precio_oferta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Precio de venta estimado</strong></small>
													</td>
													<td>
														<small>20</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c20_comp_precio_venta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. Catastral</strong></small>
													</td>
													<td>
														<small>21</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c21_comp_supf_catastral }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. construida estimada</strong></small>
													</td>
													<td>
														<small>22</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c22_comp_supf_estimada }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Supf. parcela</strong></small>
													</td>
													<td>
														<small>23</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c23_comp_supf_parcela }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Precio unitario</strong></small>
													</td>
													<td>
														<small>24</small>
													</td>
													<td>
														<small>9(12)</small>
													</td>
													<td>
														<small>{{ value.c24_comp_precio_unitario }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Año construcción</strong></small>
													</td>
													<td>
														<small>25</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c25_comp_ano_construccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Año última rehab.</strong></small>
													</td>
													<td>
														<small>26</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c26_comp_ano_ultima_rehab }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Tipo vivienda</strong></small>
													</td>
													<td>
														<small>27</small>
													</td>
													<td>
														<small>9(1)</small>
													</td>
													<td>
														<small>{{ value.c27_comp_tipo_vivienda }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº baños</strong></small>
													</td>
													<td>
														<small>28</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c28_comp_num_banos }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº dormitorios</strong></small>
													</td>
													<td>
														<small>29</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c29_comp_num_dormitorios }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Zonas verdes</strong></small>
													</td>
													<td>
														<small>30</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c30_comp_zonas_verdes }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Piscina</strong></small>
													</td>
													<td>
														<small>31</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c31_comp_piscina }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Zonas deportivas</strong></small>
													</td>
													<td>
														<small>32</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c32_comp_zonas_deportivas }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Calefacción</strong></small>
													</td>
													<td>
														<small>33</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c33_comp_calefaccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Aire acondicionado</strong></small>
													</td>
													<td>
														<small>34</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c34_comp_aire_acondicionado }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Calidad construcción</strong></small>
													</td>
													<td>
														<small>35</small>
													</td>
													<td>
														<small>9(1)</small>
													</td>
													<td>
														<small>{{ value.c35_comp_calidad_construccion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Estado conservación</strong></small>
													</td>
													<td>
														<small>36</small>
													</td>
													<td>
														<small>9(1)</small>
													</td>
													<td>
														<small>{{ value.c36_comp_estado_conservacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Terraza cubierta m2</strong></small>
													</td>
													<td>
														<small>37</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c37_comp_m2_terraza_cubierta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Terraza descubierta m2</strong></small>
													</td>
													<td>
														<small>38</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c38_comp_m2_terraza_descubierta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Ascensor</strong></small>
													</td>
													<td>
														<small>39</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c39_comp_ascensor }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº planta</strong></small>
													</td>
													<td>
														<small>40</small>
													</td>
													<td>
														<small>-9(3)</small>
													</td>
													<td>
														<small>{{ value.c40_comp_num_planta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Tipo de planta</strong></small>
													</td>
													<td>
														<small>41</small>
													</td>
													<td>
														<small>X(2)</small>
													</td>
													<td>
														<small>{{ value.c41_comp_tipo_planta }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº plazas garaje</strong></small>
													</td>
													<td>
														<small>42</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c42_comp_num_plazas_garaje }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Trastero</strong></small>
													</td>
													<td>
														<small>43</small>
													</td>
													<td>
														<small>X(1)</small>
													</td>
													<td>
														<small>{{ value.c43_comp_trastero }}</small>
													</td>
												</tr>


											</table>

										</div>
									</form>
								</div>

							</div>
						</v-tab>
						<v-tab :title="bde_relationships_files_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">

										<div class="section-container">
											<h3>Relaciones {{ filesyear }}</h3>
											<!--<pre>{{ bde_realestate_files }}</pre>-->
											<h4>Resumen:</h4>
											<table class="table-striped calc" style="margin-bottom: 3em;">
												<tr>
													<td>
														<small><strong>Número de filas</strong></small>
													</td>
													<td>
														<small> {{ numrelaciones }}</small>
													</td>
												</tr>

											</table>
											<h4>Fichero de entrega BdE:</h4>
											<div class="field-container">

												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenRelationshipsFile"
															@keyup.enter="onOpenRelationshipsFile">
										<span><icon name="external-link" scale="0.8"
													color="rgb(0, 79, 146)"></icon>&nbsp;<small>Abrir ficha de entrega</small></span>
													</button>
												</div>
												<div class="field__group">
													<label class="field__group__label">Separador ";"</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="separator"
														   @click="set_separator">
												</div>
												<div class="field__group">
												</div>
											</div>
											<br>
											<h4>Fichas individuales:</h4>

											<table class="table-striped calc"
												   v-for="(value, key) in bde_relationships_files[filesyear]"
												   style="margin-bottom: 3em;">
												<caption style="text-align: left">
													<small><strong># {{ key }} </strong></small>
												</caption>
												<tr>
													<th width="200px" style="text-align: right">
														<small><strong>Campo</strong></small>
													</th>
													<th width="40px" style="text-align: right">
														<small>Nº</small>
													</th>
													<th width="70px" style="text-align: right">
														<small>Formato</small>
													</th>
													<th width="300px" style="text-align: right">
														<small>Valor</small>
													</th>
												</tr>
												<tr>
													<td>
														<small><strong>Código sociedad</strong></small>
													</td>
													<td>
														<small>1</small>
													</td>
													<td>
														<small>9(4)</small>
													</td>
													<td>
														<small>{{ value.c01_rel_cod_sociedad }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Fecha de referencia</strong></small>
													</td>
													<td>
														<small>2</small>
													</td>
													<td>
														<small>9(6)</small>
													</td>
													<td>
														<small>{{ value.c02_rel_fecha_ref }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Número de tasación</strong></small>
													</td>
													<td>
														<small>3</small>
													</td>
													<td>
														<small>9(20)</small>
													</td>
													<td>
														<small>{{ value.c03_rel_num_tasacion }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Nº elemento en informe</strong></small>
													</td>
													<td>
														<small>4</small>
													</td>
													<td>
														<small>9(3)</small>
													</td>
													<td>
														<small>{{ value.c04_rel_num_elemento }}</small>
													</td>
												</tr>
												<tr>
													<td>
														<small><strong>Código identificador del comparable</strong>
														</small>
													</td>
													<td>
														<small>5</small>
													</td>
													<td>
														<small>X(20)</small>
													</td>
													<td>
														<small>{{ value.c05_rel_codigoidcomparable }}</small>
													</td>
												</tr>


											</table>

										</div>

									</form>
								</div>

							</div>
						</v-tab>

					</vue-tabs>


					<bar>
					</bar>

				</div>
			</div>
		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, objectsMixin, utilsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    const {map} = require('p-iteration')
    const {forEach} = require('p-iteration')

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'bdefiles-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin,
            utilsMixin
        ],

        data: () => ({
            master_loading: true,
            loading: true,
            query_comparables_loading: false,
            bdefilesOpen: false,
            adOpen: false,
            editabletrue: true,
            error: null,
			separator: false,
            success_message: null,
            queryComparableTypeValue: null,
            new_ad_button_text: Vue.i18n.translate('Add_ad_manually'),
            add_ad_text: Vue.i18n.translate('Add_ad'),
            query_bdefiles_text: Vue.i18n.translate('Query_bdefiles'),
            bdefiles_index_text: Vue.i18n.translate('BDE_files_index'),
            bdefiles_text: Vue.i18n.translate('Ads'),
            //bde_appraisal_files_text: Vue.i18n.translate('BdE_appraisal_files'),
            //bde_realestate_files_text: Vue.i18n.translate('BdE_realestate_files'),
            //bde_comparable_files_text: Vue.i18n.translate('BdE_comparable_files'),
            //bde_relationships_files_text: Vue.i18n.translate('BdE_relationships_files'),
            bde_appraisal_files_text: 'Tasaciones',
            bde_realestate_files_text: 'Inmuebles',
            bde_comparable_files_text: 'Comparables',
            bde_relationships_files_text: 'Relaciones',
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            lat_lng_error_text: Vue.i18n.translate('Lat_lng_missing_error_text'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            bdefiles_by_years: null,
            filesyear: null,
			numtasaciones: null,
			valortasaciones: null,
			numinmuebles: null,
			valorinmuebles: null,
			numcomparables: null,
			numrelaciones: null

        }),

        created () {

            this.filesyear = this.$route.query.filesyear

            this.numtasaciones = _.size(this.bde_appraisal_files[this.filesyear])
            this.valortasaciones = _.sumBy(_.values(this.bde_appraisal_files[this.filesyear]), function (value) {
                if (value.c11_valor_tasacion) {
                    if (isNaN(Number(value.c11_valor_tasacion))) {
                        return 0
                    } else {
                        return Number(value.c11_valor_tasacion)
                    }
                } else {
                    return 0
                }
            })
            this.numinmuebles = _.size(this.bde_realestate_files[this.filesyear])
            this.valorinmuebles = _.sumBy(_.values(this.bde_realestate_files[this.filesyear]), function (value) {
                if (value.c14_inm_valor_tasacion) {
                    if (isNaN(Number(value.c14_inm_valor_tasacion))) {
                        return 0
                    } else {
                        return Number(value.c14_inm_valor_tasacion)
                    }
                } else {
                    return 0
                }
            })

            this.numcomparables = _.size(this.bde_comparable_files[this.filesyear])

            this.numrelaciones = _.size(this.bde_relationships_files[this.filesyear])



            this.master_loading = false

        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        }
        ,

        computed: {
            ...
                mapGetters([
                    'theme',
                    'currentLocale',
                    'appraisalreports',
                    'appraisalinvoices',
                    'appraisalfiles',
                    'appraisals',
                    'realestates',
                    'marketstudies',
                    'ad_comparables',
                    'realestates',
                    'warnings',
                    'constraints',
                    'bde_appraisal_files',
                    'bde_realestate_files',
                    'bde_comparable_files',
                    'bde_relationships_files'
                ])
        }
        ,

        methods: {
            ...
                mapActions(
                    [
                        'FETCH_APPRAISALREPORTS',
                        'FETCH_APPRAISALS',
                        'FETCH_APPRAISALFILES',
                        'FETCH_MARKETSTUDIES',
                        'FETCH_AD_COMPARABLES',
                        'FETCH_APPRAISALINVOICES',
                        'FETCH_REALESTATES',
                        'FETCH_WARNINGS',
                        'FETCH_CONSTRAINTS',
                        'SET_BDE_APPRAISAL_FILES',
                        'SET_BDE_REALESTATE_FILES',
                        'SET_BDE_COMPARABLE_FILES',
                        'SET_BDE_RELATIONSHIPS_FILES'
                    ]),
            onOpenAppraisalFile: function (data) {

                let sep_char = ''

				if(this.separator === true){
                    console.log("separant!")
				 sep_char = ";"
				}

                let formatHtml = function (string) {
                    let s = string
                    //non breaking space
                    s = _.replace(s, new RegExp(' ', 'g'), '&nbsp;')
                    //non breaking hyphen
                    s = _.replace(s, new RegExp('-', 'g'), '&#8209;')
                    //non breaking hyphen type2
                    s = _.replace(s, new RegExp('/\u2013', 'g'), '&#8209;')
                    //non breaking hyphen type3
                    s = _.replace(s, new RegExp('/\u2014', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')

                    // Ja haurien de venir sense tabs ni newlines
                    //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                    //s = _.replace(s, new RegExp('\n', 'g'), '')

                    return s
                }
                //
                let win = window.open('', 'Tasaciones', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + (screen.height) + ',left=' + (screen.width - 768))

                let wrapper_pre1 = '<html><head><title>Ficha de Tasaciones ' + this.filesyear
                let wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>'
                let wrapper_post = '</body></html>'

                win.document.write(wrapper_pre1)
                win.document.write(wrapper_pre2)

                _.forEach(this.bde_appraisal_files[this.filesyear], function (value) {

                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_cod_sociedad) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_fecha_ref) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_num_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_fecha_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_tipo_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c06_finalidad_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c07_sigue_leymh) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c08_sigue_eco) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c09_hay_advertencias) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c10_hay_condicionantes) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c11_valor_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c12_importe_facturado) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c13_nif_mandatario) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c14_nombre_mandatario) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c15_codigo_mandatario) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c16_nif_solicitante) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c17_nombre_solicitante) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c18_nif_tasador) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c19_nombre_tasador) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c20_nif_supervisor) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c21_nombre_supervisor) + sep_char + '</span>')

                    win.document.write('<br>')

                })

                win.document.write(wrapper_post)

            },
            set_separator: function (e) {

                console.log('ahi va, separator: ')
				console.log(this.separator)

            },
            onOpenRealestateFile: function (data) {

                let sep_char = ''

                if(this.separator === true){
                    console.log("separant!")
                    sep_char = ";"
                }

                let formatHtml = function (string) {
                    let s = string
                    //non breaking space
                    s = _.replace(s, new RegExp(' ', 'g'), '&nbsp;')
                    //non breaking hyphen
                    s = _.replace(s, new RegExp('-', 'g'), '&#8209;')
                    //non breaking hyphen type2
                    s = _.replace(s, new RegExp('/\u2013', 'g'), '&#8209;')
                    //non breaking hyphen type3
                    s = _.replace(s, new RegExp('/\u2014', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')

                    // Ja haurien de venir sense tabs ni newlines
                    //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                    //s = _.replace(s, new RegExp('\n', 'g'), '')

                    return s
                }
                //
                let win = window.open('', 'Inmuebles', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + (screen.height) + ',left=' + (screen.width - 768))

                let wrapper_pre1 = '<html><head><title>Ficha de Inmuebles ' + this.filesyear
                let wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>'
                let wrapper_post = '</body></html>'

                win.document.write(wrapper_pre1)
                win.document.write(wrapper_pre2)

                _.forEach(this.bde_realestate_files[this.filesyear], function (value) {

                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_inm_cod_sociedad) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_inm_fecha_ref) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_inm_num_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_inm_num_elemento) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_inm_tipo_activo) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c06_inm_tipo_vivienda) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c07_inm_tipo_uso) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c08_inm_estado_ocupacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c09_inm_visita_interior) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c10_inm_estado_construccion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c11_inm_ano_construccion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c12_inm_ano_ultima_rehab) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c13_inm_metodo_valoracion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c14_inm_valor_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c15_inm_valor_hipotesis_edif_terminado) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c16_inm_valor_reemplazamiento_neto) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c17_inm_valor_max_legal) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c18_inm_valor_actualizacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c19_inm_valor_comparacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c20_inm_ajuste_valor_comparacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c21_inm_valor_hipotecario) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c22_inm_pais) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c23_inm_codigo_ine) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c24_inm_nombre_municipio) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c25_inm_direccion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c26_inm_codigo_postal) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c27_inm_ref_catastral) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c28_inm_idufir) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c29_inm_seccion_censal) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c30_inm_longitud_geolocalizacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c31_inm_latitud_geolocalizacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c32_inm_supf_const) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c33_inm_supf_const_con_zc) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c34_inm_supf_util) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c35_inm_supf_catastral) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c36_inm_supf_adoptada) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c37_inm_supf_parcela) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c38_inm_valor_unitario) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c39_inm_costes_construccion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c40_inm_otros_gastos_unitarios) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c41_inm_num_banos) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c42_inm_num_dormitorios) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c43_inm_zonas_verdes) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c44_inm_piscina) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c45_inm_zonas_deportivas) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c46_inm_calefaccion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c47_inm_aire_acondicionado) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c48_inm_calidad_construccion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c49_estado_conservacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c50_inm_m2_terraza_cubierta) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c51_inm_m2_terraza_descubierta) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c52_inm_ascensor) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c53_inm_num_planta) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c54_inm_tipo_planta) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c55_inm_plazas_garaje) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c56_inm_trastero) + sep_char + '</span>')

                    win.document.write('<br>')

                })

                win.document.write(wrapper_post)

            },
            onOpenComparableFile: function (data) {

                let sep_char = ''

                if(this.separator === true){
                    console.log("separant!")
                    sep_char = ";"
                }

                let formatHtml = function (string) {
                    let s = string
                    //non breaking space
                    s = _.replace(s, new RegExp(' ', 'g'), '&nbsp;')
                    //non breaking hyphen
                    s = _.replace(s, new RegExp('-', 'g'), '&#8209;')
                    //non breaking hyphen type2
                    s = _.replace(s, new RegExp('/\u2013', 'g'), '&#8209;')
                    //non breaking hyphen type3
                    s = _.replace(s, new RegExp('/\u2014', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')

                    // Ja haurien de venir sense tabs ni newlines
                    //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                    //s = _.replace(s, new RegExp('\n', 'g'), '')

                    return s
                }
                //
                let win = window.open('', 'Inmuebles', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + (screen.height) + ',left=' + (screen.width - 768))

                let wrapper_pre1 = '<html><head><title>Ficha de Comparables ' + this.filesyear
                let wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>'
                let wrapper_post = '</body></html>'

                win.document.write(wrapper_pre1)
                win.document.write(wrapper_pre2)

                _.forEach(this.bde_comparable_files[this.filesyear], function (value) {

                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_comp_cod_sociedad) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_comp_fecha_ref) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_comp_identificador) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_comp_fecha_captura) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_comp_tipo_datos) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c06_comp_visita_interior) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c07_comp_contraste_catastro) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c08_comp_datos_contacto) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c09_comp_pais) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c10_comp_codigo_ine) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c11_comp_municipio) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c12_comp_direccion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c13_comp_codigo_postal) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c14_comp_ref_catastral) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c15_comp_idufir) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c16_comp_seccion_censal) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c17_comp_longitud) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c18_comp_latitud) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c19_comp_precio_oferta) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c20_comp_precio_venta) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c21_comp_supf_catastral) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c22_comp_supf_estimada) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c23_comp_supf_parcela) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c24_comp_precio_unitario) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c25_comp_ano_construccion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c26_comp_ano_ultima_rehab) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c27_comp_tipo_vivienda) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c28_comp_num_banos) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c29_comp_num_dormitorios) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c30_comp_zonas_verdes) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c31_comp_piscina) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c32_comp_zonas_deportivas) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c33_comp_calefaccion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c34_comp_aire_acondicionado) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c35_comp_calidad_construccion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c36_comp_estado_conservacion) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c37_comp_m2_terraza_cubierta) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c38_comp_m2_terraza_descubierta) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c39_comp_ascensor) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c40_comp_num_planta) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c41_comp_tipo_planta) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c42_comp_num_plazas_garaje) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c43_comp_trastero) + sep_char + '</span>')

                    win.document.write('<br>')

                })

                win.document.write(wrapper_post)

            },
            onOpenRelationshipsFile: function (data) {

                let sep_char = ''

                if(this.separator === true){
                    console.log("separant!")
                    sep_char = ";"
                }

                let formatHtml = function (string) {
                    let s = string
                    //non breaking space
                    s = _.replace(s, new RegExp(' ', 'g'), '&nbsp;')
                    //non breaking hyphen
                    s = _.replace(s, new RegExp('-', 'g'), '&#8209;')
                    //non breaking hyphen type2
                    s = _.replace(s, new RegExp('/\u2013', 'g'), '&#8209;')
                    //non breaking hyphen type3
                    s = _.replace(s, new RegExp('/\u2014', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')
                    //
                    s = _.replace(s, new RegExp('‑', 'g'), '&#8209;')

                    // Ja haurien de venir sense tabs ni newlines
                    //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                    //s = _.replace(s, new RegExp('\n', 'g'), '')

                    return s
                }
                //
                let win = window.open('', 'Relaciones', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + (screen.height) + ',left=' + (screen.width - 768))

                let wrapper_pre1 = '<html><head><title>Ficha de Relaciones ' + this.filesyear
                let wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>'
                let wrapper_post = '</body></html>'

                win.document.write(wrapper_pre1)
                win.document.write(wrapper_pre2)

                _.forEach(this.bde_relationships_files[this.filesyear], function (value) {

                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_rel_cod_sociedad) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_rel_fecha_ref) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_rel_num_tasacion) + sep_char + '</span>')
                    win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_rel_num_elemento) + sep_char + '</span>')
                    win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_rel_codigoidcomparable) + sep_char + '</span>')

                    win.document.write('<br>')

                })

                win.document.write(wrapper_post)

            },

        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'BDE files'
            }

        }
    }
</script>


// WEBPACK FOOTER //
// BdefilesEditor.vue?0e750529